var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingio-spinner-rolling-l8pfz6cbtd",style:({'width' : 100*_vm.ratio + 'px','height' : 100*_vm.ratio + 'px' })},[_c('div',{staticClass:"ldio-r8h14oufgyb",style:({'transform' : _vm.transform})},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }